export class CreateUpdateMenuScreenEntity {
  key?: string
  name?: string | null
  sortOrder?: number
  section?: string | null
  isActive?: boolean
}
